import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f45cd68")

_pushScopeId("data-v-3f45cd68")
const _hoisted_1 = { style: {"background":"#FFFFFF","padding":"20px"} }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 0,
  style: {"color":"#f56c6c"},
  class: "font-size12px"
}
const _hoisted_5 = { class: "week-checkbox" }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = {
  key: 0,
  class: "status-on"
}
const _hoisted_8 = {
  key: 1,
  class: "status-off"
}
const _hoisted_9 = { class: "text-align-left" }
const _hoisted_10 = {
  key: 0,
  class: "display-flex"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "height20px" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_sec_date_picker = _resolveComponent("sec-date-picker")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_time_picker = _resolveComponent("el-time-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _component_list = _resolveComponent("list")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumb }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        class: "set-page-form-width",
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.ChangeWordList.PMSetAccessBuildOrDepartment,
            prop: "Build"
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.Build,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Build = $event)),
                style: {"width":"100%"}
              }, {
                default: _withId(() => [
                  (_ctx.projectType==='community')
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.buildOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item.key,
                          label: item.value,
                          value: item.key
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_ctx.projectType==='office')
                      ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.departmentOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_cus_option, {
                            key: item.key,
                            label: item.value,
                            value: item.key
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.formData.Build !=='' && _ctx.projectType === 'community')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _ctx.$wordList.ProperAllTextApt,
                prop: "Room"
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.formData.Room,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Room = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aptOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item.key,
                          label: item.value,
                          value: item.key
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.formData.Build !=='' && _ctx.projectType === 'office')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: _ctx.$wordList.ProperAllTextPeople
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.formData.OfficeUserID,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.OfficeUserID = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.peopleOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item.key,
                          label: item.value,
                          value: item.key
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextName,
            prop: "Description"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Description,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.Description = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextIdNumber,
            prop: "IDNumber"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.IDNumber,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.IDNumber = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextRepeats
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.SchedulerType,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.SchedulerType = $event)),
                style: {"width":"100%"}
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.repeatsOption, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.formData.SchedulerType === _ctx.access.neverEachCounts)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TmpKeyListTanleBeginTime,
                  prop: "BeginTime"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_sec_date_picker, {
                      style: {"width":"100%"},
                      modelValue: _ctx.formData.BeginTime,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.BeginTime = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TmpKeyListTanleEndTime,
                  prop: "ExpireTime"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_sec_date_picker, {
                      style: {"width":"100%"},
                      modelValue: _ctx.formData.ExpireTime,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.ExpireTime = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_3,
                    (_ctx.isShowTimeRangeTips)
                      ? (_openBlock(), _createBlock("label", _hoisted_4, _toDisplayString(_ctx.$wordList.LimitTimeRange), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.formData.SchedulerType === _ctx.access.weekly)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                label: _ctx.$wordList.NavInHtmlDay,
                prop: "DateFlag"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.formData.DateFlag,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.DateFlag = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_5, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.access.weekList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            class: "min-width100px",
                            key: index,
                            label: index.toString()
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(item), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.formData.SchedulerType !== _ctx.access.neverEachCounts)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TmpKeyListTanleBeginTime,
                  prop: "StartTime"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_time_picker, {
                      modelValue: _ctx.formData.StartTime,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.StartTime = $event)),
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TmpKeyListTanleEndTime,
                  prop: "StopTime"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_time_picker, {
                      modelValue: _ctx.formData.StopTime,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.StopTime = $event)),
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.formData.SchedulerType == _ctx.access.neverEachCounts)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 5,
                label: _ctx.$wordList.EachDoorCounts,
                prop: "Allow"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.Allow,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.Allow = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextDeliveryMethod,
            prop: "Delivery"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Delivery,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.Delivery = $event)),
                placeholder: _ctx.$wordList.ProperAllTextEmail
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"]),
      _createVNode(_component_list, {
        class: "set-page-list-width",
        headers: _ctx.headers,
        update: _ctx.updateToList,
        "request-data": _ctx.listRequestData,
        showCheck: false,
        action: false,
        dealList: _ctx.dealList
      }, {
        StatusSlot: _withId((data) => [
          (data.scope.Status === _ctx.access.statusOn.toString())
            ? (_openBlock(), _createBlock("div", _hoisted_7))
            : _createCommentVNode("", true),
          (data.scope.Status === _ctx.access.statusOff.toString())
            ? (_openBlock(), _createBlock("div", _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        RelaySlotHeader: _withId((data) => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.allCheck,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.allCheck = $event)),
            onChange: _ctx.changeAllCheck
          }, null, 8, ["modelValue", "onChange"]),
          _createTextVNode(" " + _toDisplayString(data.scope.label), 1)
        ]),
        RelaySlot: _withId((data) => [
          _createVNode("div", _hoisted_9, [
            (_ctx.checkArray[data.scope.MAC])
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.checkArray[data.scope.MAC].Relay,
                    "onUpdate:modelValue": ($event: any) => (_ctx.checkArray[data.scope.MAC].Relay = $event),
                    onChange: _ctx.choose,
                    class: data.scope.Relay.length > 0 ? 'margin-right10px' : ''
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.scope.Relay, (checkItem) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          class: "margin-right10px",
                          label: checkItem.key,
                          key: checkItem
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(checkItem.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "class"]),
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.checkArray[data.scope.MAC].Security,
                    "onUpdate:modelValue": ($event: any) => (_ctx.checkArray[data.scope.MAC].Security = $event),
                    onChange: _ctx.choose
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.scope.SecurityRelay, (checkItem) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          class: "margin-right10px",
                          label: checkItem.key,
                          key: checkItem
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(checkItem.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["headers", "update", "request-data", "dealList"]),
      _hoisted_11,
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.submit
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})